// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__23Rts","label":"Section_label__YN8WH","contentWrap":"Section_contentWrap__qfO_b","footer":"Section_footer__CoDO8","footerInner":"Section_footerInner__2JeTB"};